// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f095e487","453":"c395497e","455":"205a6854"}[chunkId] + ".chunk.js";
};